<h1 mat-dialog-title>{{programa.nome}}</h1>
<div mat-dialog-content class="mat-dialog-content">
  <p><span class="fw-bold" i18n="@@nivel">Nível</span>: {{programa.niveis.join(txtE)}}</p>
  <p *ngIf="conceitoCapes">
     <span class="fw-bold" i18n="@@nota_capes">Nota CAPES</span>:
    <span style="cursor: help;"
       i18n-matTooltip="@@nota_capes_descricao"
       matTooltip="Nota atribuída pela CAPES na avaliação periódica dos programas de pós-graduação. As notas variam de 1 a 7, sendo 7 a pontuação máxima."
       matTooltipPosition="above"
       i18n-aria-label="@@nota_capes"
       aria-label="Nota CAPES"
    >{{conceitoCapes}}</span>
  </p>
  <p *ngFor="let unidade of programa.unidades;"><span class="fw-bold" i18n="@@unidade">Unidade</span>: {{unidade.nome}} - {{unidade.cidade}}</p>
  <p *ngIf="programa.coordenador && programa.coordenadorSexo === 'FEMININO'"><span class="fw-bold" i18n="@@coordenadora">Coordenadora</span>: {{programa.coordenador}}</p>
  <p *ngIf="programa.coordenador && programa.coordenadorSexo !== 'FEMININO'"><span class="fw-bold" i18n="@@coordenador">Coordenador</span>: {{programa.coordenador}}</p>
  <p *ngIf="programa.viceCoordenador && programa.viceCoordenadorSexo === 'FEMININO'"><span class="fw-bold" i18n="@@vice-coordenadora">Vice-coordenadora</span>: {{programa.viceCoordenador}}</p>
  <p *ngIf="programa.viceCoordenador && programa.viceCoordenadorSexo !== 'FEMININO'"><span class="fw-bold" i18n="@@vice-coordenador">Vice-coordenador</span>: {{programa.viceCoordenador}}</p>
  <p *ngIf="programa.telefone"><span class="fw-bold" i18n="@@telefone">Telefone</span>: {{programa.telefone}}</p>
  <p *ngIf="programa.email"><span class="fw-bold" i18n="@@email">Email</span>: {{programa.email}}</p>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" style="margin-top: 20px;">
    @if (this.programa.linhas.length) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span i18n="@@linhas_pesquisa">Linhas de pesquisa</span>
      </ng-template>
      <app-linha-pesquisa [data]="this.programa.linhas"></app-linha-pesquisa>
    </mat-tab>
    }
    <mat-tab>
      <ng-template mat-tab-label>
        <span i18n="@@disciplinas">Disciplinas</span>
      </ng-template>
      <app-disciplina [idPrograma]="this.programa.id"></app-disciplina>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span i18n="@@docentes">Docentes</span>
      </ng-template>
      <app-docente [idPrograma]="this.programa.id"></app-docente>
    </mat-tab>
  </mat-tab-group>
</div>
<mat-card appearance="outlined" class="mat-card">
  <mat-card-actions>
    <div class="btn-grid-auto">
      <div>
        <button mat-stroked-button mat-dialog-close i18n="@@fechar">Fechar</button>
      </div>
      <div class="btn-text-right">
        <button *ngIf="programa.homePage" mat-raised-button color="primary" (click)="abrirUrl(programa.homePage)" i18n-title="@@visitar" title="Visitar">
          <span i18n="@@visitar_pagina">Visitar página do programa</span>
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
